import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from './api';

const Ctx = createContext(null);

function normalizeUser(userData) {
  if (!userData) return userData;
  return {
    ...userData,
    id: userData.id ?? userData.userId,
  };
}

export function AppProvider({ children }) {
  const [user, setUser]   = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(!!localStorage.getItem('token'));
  const [lang, setLang]   = useState(localStorage.getItem('lang') || 'zh');

  const toggleLang = useCallback(() => {
    setLang(prev => {
      const next = prev === 'zh' ? 'en' : 'zh';
      localStorage.setItem('lang', next);
      return next;
    });
  }, []);

  useEffect(() => {
    if (!token) { setLoading(false); return; }
    API.get('/api/game/me')
      .then(u => setUser(normalizeUser(u)))
      .catch(() => { localStorage.removeItem('token'); setToken(null); })
      .finally(() => setLoading(false));
  }, [token]);

  const login = (tok, userData) => {
    localStorage.setItem('token', tok);
    setToken(tok);
    setUser(normalizeUser(userData));
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUser(null);
  };

  const refreshUser = useCallback(() =>
    API.get('/api/game/me').then(u => {
      const normalized = normalizeUser(u);
      setUser(normalized);
      return normalized;
    }), []);

  return (
    <Ctx.Provider value={{ user, token, loading, login, logout, refreshUser, lang, toggleLang }}>
      {children}
    </Ctx.Provider>
  );
}

export const useApp = () => useContext(Ctx);
